import { RootState } from '@app/model';

export const selectIsRequestSending = (state: RootState) => state.support.isRequestSending;
